<template>
  <div class="settings-page">
    <div class="title">
      <h2>Subscription</h2>
      <StripeButton
        v-if="isPremium"
        :org-id="orgId"
        text="Payment & invoices"
      />
    </div>
    <div class="subtitle">
      Manage your <strong>{{ orgName }}</strong
      >'s subscription.
    </div>
    <section>
      <Suspense>
        <Subscription :org-id="orgId" />
        <template #fallback>
          <Loader>
            <PlansSkeleton />
          </Loader>
        </template>
      </Suspense>
    </section>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, toRefs } from "vue";

import * as inject from "@/components/inject";
import Loader from "@/components/Loader.vue";
import PlansSkeleton from "@/components/settings/PlansSkeleton.vue";
import StripeButton from "@/components/settings/StripeButton.vue";
import Subscription from "@/components/settings/Subscription.vue";

export default defineComponent({
  components: {
    Loader,
    PlansSkeleton,
    StripeButton,
    Subscription,
  },
  props: {
    orgId: {
      type: String,
      required: true,
    },
  },
  async setup(props) {
    const { orgId } = toRefs(props);
    const controller = inject.controller();
    const billing = inject.billing();

    // The Stripe customer portal is only relevant once the org has (or had)
    // a paid subscription — same condition that used to gate the dedicated
    // Billing settings page.
    const isPremium = computed(
      () => billing.value?.isOrgPremium(orgId.value).value ?? false
    );

    const org = (await controller.organization.get(orgId.value)).release();
    const orgName = org ? org.name : "";
    return {
      isPremium,
      orgName,
    };
  },
});
</script>

<style scoped lang="scss">
@use "../../styles/settings.scss";

.title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 4px;

  h2 {
    margin-bottom: 0;
  }
}
</style>
